import * as Styled from './close-button.styled'
import CLOSE_ICON from '../../../@assets/icons/close-panel.svg'

import type {JSX} from 'react'

interface CloseButtonProps {
    onClose?: () => void
    label?: string
    altText?: string
    className?: string
}

export function CloseButton({
    onClose,
    label = 'Close',
    altText = 'Close',
    className,
}: CloseButtonProps): JSX.Element {
    return (
        <Styled.CloseButton onPress={onClose} aria-label={label} className={className}>
            <Styled.Image src={CLOSE_ICON} alt={altText} />
        </Styled.CloseButton>
    )
}
